import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Button, Popover, makeStyles } from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { SEARCH_INPUT_ID } from 'src/components/Inputs/DropDownSelector/instruments';
const useStyles = makeStyles(({ palette }) => ({
    ddContainer: {
        position: 'relative'
    },
    ddButton: {
        backgroundColor: palette.input.background,
        color: `${palette.ddSelector.color}`,
        border: `1px solid ${palette.ddSelector.borderColor}`,
        height: 34,
        textTransform: 'none',
        borderRadius: 2,
        '&:disabled': {
            cursor: 'not-allowed',
            pointerEvents: 'visible'
        }
    },
    ddMenu: {
        padding: '5px 0px',
        backgroundColor: `${palette.ddSelector.background}`
    },
    label: {
        maxWidth: 'calc(100% - 30px)'
    },
    popoverPaper: {
        margin: '2px 0px 0px',
        fontSize: '14px',
        textAlign: 'left',
        listStyle: 'none',
        '-webkit-background-clip': 'padding-box',
        backgroundClip: 'padding-box',
        border: '1px solid rgba(0, 0, 0, .15)',
        borderRadius: 4,
        '-webkit-box-shadow': '0 6px 12px rgb(0 0 0 / 18%)',
        boxShadow: '0 6px 12px rgb(0 0 0 / 18%)'
    },
    listStyle: {
        overflowY: 'scroll',
        color: palette.ddSelector.color,
        margin: '-5px 0',
        maxWidth: '100%',
        '&::-webkit-scrollbar': {
            width: 5
        },
        '&::-webkit-scrollbar-track': {
            boxShadow: 'inset 0 0 5px grey',
            borderRadius: 3
        },
        '&::-webkit-scrollbar-thumb': {
            background: palette.scrollColor,
            borderRadius: 5
        }
    },
    error: {
        borderColor: '#a94442'
    }
}));
function DDButton({ className = '', disabled = false, title = '', listWidth = 350, maxHeight = 400, dropDownId = 'dropdown-size-large', buttonWidth = 180, openCallback = () => null, closeCallback = () => null, children, containerClass = '', noCaret = false, menuClass = '', isValid = true, titleElement = null, noCloseOnInnerClick = false, overflowY = 'scroll' }) {
    const classes = useStyles();
    const [isOpen, setIsOpen] = useState(false);
    const isOpenRef = useRef(false);
    const containerEl = useRef(null);
    useEffect(() => {
        isOpenRef.current = isOpen;
    }, [isOpen]);
    const openList = useCallback(() => {
        setIsOpen(true);
        openCallback();
        setTimeout(() => document.body.addEventListener('click', closeIfOpen), 0);
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    const closeList = useCallback(() => {
        setIsOpen(false);
        closeCallback();
        document.body.removeEventListener('click', closeIfOpen);
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    const closeIfOpen = useCallback((e) => {
        if (isOpenRef.current && !e.defaultPrevented) {
            closeList();
        }
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    const handleToggle = () => {
        if (isOpen) {
            closeList();
        }
        else {
            openList();
        }
    };
    const insidePopoverClickInterceptor = useCallback((event) => {
        if (noCloseOnInnerClick || event.target.id === SEARCH_INPUT_ID) {
            event.preventDefault();
        }
    }, [noCloseOnInnerClick]);
    return (React.createElement("div", { ref: containerEl, className: `${classes.ddContainer} ${containerClass}` },
        React.createElement(Button, { className: `${className} ${classes.ddButton} ${!isValid ? classes.error : ''}`, disabled: disabled, style: {
                width: buttonWidth,
                overflow: 'hidden'
            }, endIcon: noCaret ? null : React.createElement(ArrowDropDownIcon, { className: `rotatable-vertically ${isOpen ? 'rotate' : ''}` }), onClick: handleToggle, id: dropDownId }, titleElement || React.createElement("span", { className: `${classes.label} line-clamp-ellipsis` }, title)),
        React.createElement(Popover, { open: isOpen, anchorEl: containerEl.current, transitionDuration: 200, elevation: 0, PaperProps: {
                className: classes.popoverPaper,
                onClickCapture: insidePopoverClickInterceptor
            }, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left'
            }, transformOrigin: {
                vertical: 'top',
                horizontal: 'left'
            } },
            React.createElement("div", { className: `${classes.ddMenu} ${menuClass}` },
                React.createElement("div", { style: {
                        width: listWidth,
                        maxHeight,
                        overflowY
                    }, className: classes.listStyle }, children)))));
}
export default DDButton;
